import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Unlock, Smartphone, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { goToCheckout } from '../constants/checkout';
export function WhatIsIncluded() {
  const items = ['Control Total Hoy', 'En Tu Primer Encuentro', 'Hoja de Ruta', 'Mi Camino al Control Total', 'Video práctico de ejercicios', 'Material descargable'];
  return <section id="que-incluye" className="py-24 bg-dark-bg relative overflow-hidden border-t border-white/10 scroll-mt-20" data-id="element-171">
      <div className="absolute inset-0 bg-hero-glow opacity-50" data-id="element-172"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-173">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-174">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-175">
            <img src="https://cdn.magicpatterns.com/uploads/9Gv38rNbthp43zq6BtSB3R/ChatGPT_Image_19_jun_2026,_21_34_38.png" alt="Pack Completo Control Total Hoy" className="w-full h-auto drop-shadow-[0_0_40px_rgba(0,170,255,0.2)]" data-id="element-176" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2" data-id="element-177">
            <h2 className="text-5xl md:text-7xl font-teko font-bold text-white mb-8" data-id="element-178">
              TODO LO QUE{' '}
              <span className="text-electric-blue text-glow-blue" data-id="element-179">INCLUYE</span>
            </h2>

            <div className="bg-panel-bg/80 border border-white/10 rounded-2xl p-8 backdrop-blur-sm mb-8" data-id="element-180">
              <ul className="space-y-4" data-id="element-181">
                {items.map((item, idx) => <li key={idx} className="flex items-center gap-4 text-xl font-medium text-gray-200" data-id="element-182">
                    <CheckCircle2 className="w-6 h-6 text-electric-blue shrink-0" data-id="element-183" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10" data-id="element-184">
              <div className="bg-black border border-white/5 p-4 rounded-xl flex flex-col items-center text-center gap-2" data-id="element-185">
                <Gift className="w-8 h-8 text-intense-red" data-id="element-186" />
                <span className="text-sm font-bold text-gray-300 uppercase" data-id="element-187">
                  Bonus incluidos
                </span>
              </div>
              <div className="bg-black border border-white/5 p-4 rounded-xl flex flex-col items-center text-center gap-2" data-id="element-188">
                <Unlock className="w-8 h-8 text-electric-blue" data-id="element-189" />
                <span className="text-sm font-bold text-gray-300 uppercase" data-id="element-190">
                  Acceso inmediato
                </span>
              </div>
              <div className="bg-black border border-white/5 p-4 rounded-xl flex flex-col items-center text-center gap-2" data-id="element-191">
                <Smartphone className="w-8 h-8 text-gray-400" data-id="element-192" />
                <span className="text-sm font-bold text-gray-300 uppercase" data-id="element-193">
                  Celular, Tablet, PC
                </span>
              </div>
            </div>

            <Button variant="primary" size="lg" fullWidth onClick={goToCheckout} data-id="element-194">
              QUIERO TODO EL PACK AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}